export { StoreDetailsWrapper } from "./store-details-wrapper";
